export default "__VITE_ASSET__CRb9Zx9B__"